export enum KeysOverride {
	NONE = 'NONE',
	KEYNAME = 'KEYNAME',
	LONGTEXT = 'LONGTEXT',
	EMPTY = 'EMPTY',
}
